import { supabase } from "./supabase";

export const BUCKET_PIECES_JUSTIFICATIVES = "pieces-justificatives";

/** Indique si la valeur stockée en base correspond au bucket pièces justificatives (chemin relatif ou ancienne URL publique Supabase). */
export function isStoredPiecesJustificativesField(stored: string | null | undefined): boolean {
  const s = (stored ?? "").trim();
  if (!s) return false;
  if (s.startsWith("blob:") || s.startsWith("data:")) return false;
  if (/^https?:\/\//i.test(s)) {
    return s.includes(`/object/public/${BUCKET_PIECES_JUSTIFICATIVES}/`) || s.includes(`/${BUCKET_PIECES_JUSTIFICATIVES}/`);
  }
  return true;
}

/** Extrait le chemin objet dans le bucket à partir d'une URL publique legacy ou retourne la chaîne si c'est déjà un chemin. */
export function storagePathFromStoredPieceField(stored: string): string | null {
  const s = stored.trim();
  if (!s) return null;
  const marker = `/object/public/${BUCKET_PIECES_JUSTIFICATIVES}/`;
  if (/^https?:\/\//i.test(s) && s.includes(marker)) {
    try {
      const u = new URL(s);
      const idx = u.pathname.indexOf(marker);
      if (idx === -1) return null;
      return decodeURIComponent(u.pathname.slice(idx + marker.length));
    } catch {
      return null;
    }
  }
  if (/^https?:\/\//i.test(s)) return null;
  return s.replace(/^\/+/, "");
}

export async function createSignedPiecesJustificativesUrl(
  stored: string | null | undefined,
  expiresSec = 7200
): Promise<string | null> {
  if (!isStoredPiecesJustificativesField(stored)) return null;
  const path = storagePathFromStoredPieceField(String(stored).trim());
  if (!path) return null;
  const { data, error } = await supabase.storage
    .from(BUCKET_PIECES_JUSTIFICATIVES)
    .createSignedUrl(path, expiresSec);
  if (error || !data?.signedUrl) return null;
  return data.signedUrl;
}

/** Résout une URL affichable : signed URL pour notre bucket privé, sinon la valeur d'origine (autres buckets / URLs). */
export async function resolveFileOrPieceUrl(stored: string | null | undefined, expiresSec = 7200): Promise<string | null> {
  const s = (stored ?? "").trim();
  if (!s) return null;
  if (s.startsWith("blob:") || s.startsWith("data:")) return s;
  if (isStoredPiecesJustificativesField(s)) {
    const signed = await createSignedPiecesJustificativesUrl(s, expiresSec);
    return signed ?? s;
  }
  return s;
}
